import {
  v2PwaBasePath,
  projectBasePathWithFolder,
  imgBaseUrl,
  shouldHideCompleteLocationFlow,
  keyForEncryDecry,
} from "../config/apiEndpoints";
import store from "../store/index";
import LocalStorageFunc from "./localStorageFunc";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import PageNames from "../config/pageNames";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY,
} from "../config/vwoKeys";
import { MINIAPP } from "./paymentConstants";
import gpayUtility from "./gpayUtility";
import paytmMicroapp from "./paytmMicroapp";
import CryptoJs from "crypto-js";

const randomnumber = (minimum = 100000000, maximum = 999999999) => {
  return Math.floor(Math.random() * (maximum - minimum, maximum + 1)) + minimum;
};

const pizzaCounter = () => {
  if (!!window.IntersectionObserver) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            store.commit(
              keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
              entry.target.id
            );
          }
        });
      },
      {
        root: null,
        threshold: pizzaCounterThreshold(), //0.1 for anchor links
        rootMargin: pizzaCounterRootMargin(),
      }
    );
    store.commit(keyMapsMutation.SET_PRODUCT_OBSERVER, observer);
  }
};

const pizzaCounterRootMargin = () => {
  let vwoExperimentName = LocalStorageFunc.getSessionStorageKey(
    "VWO_PWA_V2_VARIATIONS"
  );
  let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
  if (
    exp === "nextgen_variant_u" ||
    exp === "nextgen_variant_w" ||
    exp === "nextgen_variant_y" ||
    LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") === "home"
  ) {
    return "-150px 0% 0% 0%";
  } else if (exp === "nextgen_variant_x") {
    return "-111px 0% 0% 0%";
  }
  return "-10% 0% -80% 0%";
};

const pizzaCounterThreshold = () => {
  let vwoExperimentName = LocalStorageFunc.getSessionStorageKey(
    "VWO_PWA_V2_VARIATIONS"
  );

  let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
  if (
    exp === "nextgen_variant_s" ||
    exp === "nextgen_variant_u" ||
    exp === "nextgen_control" ||
    exp === "nextgen_variant_w" ||
    exp === "nextgen_variant_y" ||
    exp === "nextgen_control" ||
    LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") === "home"
  )
    return 0;
  else return 0.1;
};

const tryJsonParse = (value, defaultValue = {}) => {
  let _;
  if (value === null || value === "null") return defaultValue;
  try {
    _ = JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
  return _;
};

const checkNextgenVariant = (currentExperimentValue) => {
  return true;
  return (
    currentExperimentValue?.startsWith("nextgen_variant_") || isNoRedirectTrue()
  );
};

const calculateIsTrueLocationDetectedFromLocationSource = () => {
  return LocalStorageFunc.getLocationSource() == "ip" ? false : true;
};

const checkIfOrderTypeNonDelivery = (deliveryType) =>
  !!(deliveryType === 'P' || deliveryType === 'DINEIN' || deliveryType === 'CURB');

const takeawayDineinFolder = (isTrueLocationDetected) => {
  if (isTrueLocationDetected) {
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore`;
  }
  const takeawayLocation = getSessionStorageValue("takeawayLocation");
  if (typeof takeawayLocation != "undefined" && takeawayLocation) {
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore`;
  }

  return `${window?._siteProps_?.props?.postorderUIBasepath}searchAddress`;
};

const redirectUrlForNonDeliveryOrderType = (
  isTrueLocationDetected,
  deliveryType
) => {
  const takeAwayCoords = LocalStorageFunc.getCoordsForTakeaway();
  if (!isTrueLocationDetected && takeAwayCoords) {
    const { latitude, longitude } = takeAwayCoords?.coords || {};
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore?deliveryType=${deliveryType}&latitude=${latitude}&longitude=${longitude}`;
  }
  let redirectUrl = takeawayDineinFolder(isTrueLocationDetected);
  return `${redirectUrl}?deliveryType=${deliveryType}`;
};

const deliveryFolder = (isLoggedIn) => {
  if (isLoggedIn) {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    if (Array.isArray(userAddresses) && userAddresses.length > 0)
      return "address";
  }
  return "changeAddress";
};

const textLowerAndTrimSpace = (text) =>
  text.toLocaleLowerCase().replace(/\s/g, "");

const getPwaV2CurrentCustomisation = (
  productId,
  currentCustomisation,
  toppingsData
) => {
  let extraKeys = {};

  let extraCheeseToppings = {
    price: { 6: "50.00", 7: "75.00", 8: "95.00" },
    toppingId: 51,
    description: "",
    name: "Extra Cheese",
    images: "extraCheese.jpg",
    type: 2,
    custAttrField: "C.",
  };

  if (currentCustomisation[productId]?.addTopngs) {
    extraKeys["addTopngs"] = currentCustomisation[productId].addTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      }
    );
  }

  if (currentCustomisation[productId]?.remTopngs) {
    extraKeys["remTopngs"] = currentCustomisation[productId].remTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      }
    );
  }
  if (currentCustomisation[productId]?.repTopngs) {
    extraKeys["repTopngs"] = currentCustomisation[productId].repTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      }
    );
  }
  return {
    ...currentCustomisation[productId],
    ...extraKeys,
  };
};

const getProductHashcode = (code, id) => {
  return (code || "") + (id || "");
}

const keybasedProductItem = (_) => {
  let response = {};
  let priceHashCode = {};
  _?.forEach((__) => {
    let temp2 = {};
    __.data?.forEach((___) => {
      const hashCode = getProductHashcode(___.code, ___.id);
      temp2[hashCode] = ___;
      priceHashCode[hashCode] = {};
      temp2[hashCode]["customCategoryId"] = __.categoryId;
      temp2[hashCode]["customCategoryName"] = __.categoryName;

      temp2[hashCode].crust?.map((c) => {
        priceHashCode[hashCode][c.crustId] = {};
        c?.sizes?.map((s) => {
          priceHashCode[hashCode][c.crustId][s.sizeId] = s.price;
        });
      });

      if (!temp2[hashCode]["defaultPrice"]) {
        temp2[hashCode]["defaultPrice"] = +temp2[hashCode].crust
          .filter((_) => {
            if (_.crustId == temp2[hashCode].selectedCrustId) {
              temp2[hashCode]["defaultCrustName"] = _.name;
              temp2[hashCode]["crustName"] = _.name;
              temp2[hashCode]["crustId"] = temp2[hashCode].selectedCrustId;
            }
            return _.crustId == temp2[hashCode].selectedCrustId;
          })[0]
          ?.sizes.filter((_) => {
            if (_.sizeId == temp2[hashCode].selectedSizeId) {
              temp2[hashCode]["defaultSizeName"] = _.name;
              temp2[hashCode]["sizeName"] = _.name;
              temp2[hashCode]["sizeId"] = temp2[hashCode].selectedSizeId;
            }
            return _.sizeId == temp2[hashCode].selectedSizeId;
          })[0]?.price;
        temp2[hashCode]["itemPrice"] = temp2[hashCode]["defaultPrice"];
      }
      temp2[hashCode]["itemPrice"] = temp2[hashCode]["defaultPrice"];
      temp2[hashCode]["addTopngs"] = [];
      temp2[hashCode]["product"] = {
        id: temp2[hashCode]["id"],
        code: temp2[hashCode]["code"],
      };

      if (Object.keys(priceHashCode[hashCode]) == 0) {
        delete priceHashCode[hashCode];
      }
    });
    response[__.categoryName] = { ...__, data: temp2 };
  });

  return { response: response, priceHashCode: priceHashCode };
};

const addMissingKeyAccToLoadDataAndProductItems = (__) => {
  let response = [];
  let temp2 = {};
  let priceHashCode = {};

  __?.forEach((___) => {
    temp2[___.code] = ___;
    priceHashCode[___.code] = {};
    temp2[___.code].crust?.map((c) => {
      priceHashCode[___.code][c.crustId] = {};
      c?.sizes?.map((s) => {
        priceHashCode[___.code][c.crustId][s.sizeId] = s.price;
      });
    });

    if (!temp2[___.code]["defaultPrice"]) {
      temp2[___.code]["defaultPrice"] = +temp2[___.code].crust
        .filter((_) => {
          if (_.crustId == temp2[___.code].selectedCrustId) {
            temp2[___.code]["defaultCrustName"] = _.name;
          }
          if (_.crustId == temp2[___.code].orderedCrustId) {
            //temp2[___.code]["defaultCrustName"] = _.name;
            temp2[___.code]["crustName"] = _.name;
            temp2[___.code]["crustId"] = temp2[___.code].orderedCrustId;
          }
          return _.crustId == temp2[___.code].orderedCrustId;
        })[0]
        ?.sizes.filter((_) => {
          if (_.sizeId == temp2[___.code].selectedSizeId) {
            temp2[___.code]["defaultSizeName"] = _.name;
          }
          if (_.sizeId == temp2[___.code].orderedSizeId) {
            //temp2[___.code]["defaultSizeName"] = _.name;
            temp2[___.code]["sizeName"] = _.name;
            temp2[___.code]["sizeId"] = temp2[___.code].orderedSizeId;
          }
          return _.sizeId == temp2[___.code].orderedSizeId;
        })[0]?.price;
      temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
    }
    temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
    temp2[___.code]["product"] = {
      id: temp2[___.code]["id"],
      code: temp2[___.code]["code"],
    };

    if (Object.keys(priceHashCode[___.code]) == 0) {
      delete priceHashCode[___.code];
    }
    temp2[___.code]["addTopngs"] = temp2[___.code]["orderedAddToppings"] || [];
    temp2[___.code]["remTopngs"] =
      temp2[___.code]["orderedRemoveToppings"] || [];
    temp2[___.code]["repTopngs"] =
      temp2[___.code]["orderedReplaceToppings"] || []; //because of keys name change - and we use old keys

    response.push(temp2[___.code]);
  });
  return response;
};
const getCategoryIdBasedMenuCodesFromSequencing = function (data) {
  var _ = {};
  data?.map((__) => {
    if (__.categoryId) {
      _[+__.categoryId] = __.menuCodes;
    }
  });
  return _;
};

const sequencedProductItems = function (items, sequence) {
  var _ = [];
  items?.map((__) => {
    _.push({
      ...__,
      data: __.data?.sort((itemA, itemB) => {
        var itemAindex = sequence.indexOf(itemA.code);
        if (itemAindex == -1) {
          itemAindex = 200;
        }
        var itemBindex = sequence.indexOf(itemB.code);
        if (itemBindex == -1) {
          itemBindex = 300;
        }
        return itemAindex - itemBindex;
      }),
    });
  });
  return _;
};

const getCurrentToppingsTotalPrice = (toppingsMasterData, item) => {
  let sum = 0;
  item.addTopngs?.map((_) => {
    sum =
      sum +
        +toppingsMasterData.filter((__) => {
          return __.toppingId == _;
        })[0]?.price[item.sizeId] || 0;
  });
  return sum;
};

const redirectToLoginScreen = () => {
  const loginPageUrl = `/${window?._siteProps_?.props?.postorderUIBasepath}login`;
  window.location.href = v2PwaBasePath + loginPageUrl + "?redirectUrl=" + location.href;
};

const sendToLoginScreen = (location) => {
  const isMiniApp = getMiniAppStorageVal();
  if (isMiniApp === MINIAPP.GPAY) {
    gpayUtility.getGpayUserPhoneNumber(location);
  } else if (isMiniApp === MINIAPP.PAYTM) {
    paytmMicroapp.getUserDetails(location);
  } else {
    redirectToLoginScreen();
  }
  return;
};

const getAppDownloadLink = () => {
  return "https://dominos.onelink.me/uM7R/3e839899";
};

const getNoRedirectFromWindow = () => {
  const noRedirect = window?.noredirect;
  if (noRedirect === false) {
    return noRedirect;
  }
  return true;
};

const getCurrentStoreFolder = () => {
  let _ = window._siteProps_?.link_rewrite;
  let noRedirect = getNoRedirectFromWindow();

  if (_ === PageNames.NEXTGEN_LINKREWRITE_HOME && noRedirect) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_HOME}/`;
  }

  if (
    LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") ===
      PageNames.NEXTGEN_LINKREWRITE_HOME &&
    noRedirect
  ) {
    return "/menu/";
  }

  if (_ == "/") {
    _ = "";
  }
  let vwoExperimentName = LocalStorageFunc.getSessionStorageKey(
    "VWO_PWA_V2_VARIATIONS"
  );

  switch (vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]) {
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_N:
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_N}/`;
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_O:
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_O}/`;
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_P:
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_P}/`;
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S:
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_S}/`;
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL:
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.CONTROL}/`;
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U: {
      if (_ === "menu") return "/menu/";
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_U}/`;
    }
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W: {
      if (_ === "menu") return "/menu/";
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_W}/`;
    }
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X: {
      if (_ === "menu") return "/menu/";
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_X}/`;
    }
    case VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y: {
      if (_ === "menu") return "/menu/";
      return `/${VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_Y}/`;
    }
    default:
      return `/${"store" || _}/`;
  }
};

const onlyShowCategory = (elementId) => {
  let elements = document.querySelectorAll('*[id^="category_items_id_"]');
  elements.forEach((ele) => {
    if (ele.id === elementId) {
      ele.style.display = "";
    } else {
      ele.style.display = "none";
    }
  });
};

const scrollPageTo = (elmId, topValMargin = 70, behavior = "smooth") => {
  let el = document.getElementById(elmId);
  if (el !== null) {
    let top = el.offsetTop;
    function listener() {
      if (top - topValMargin - window.scrollY <= 300) {
        const newOffset = el.offsetTop;
        if (top !== newOffset) {
          window.scrollTo({
            top: newOffset - topValMargin,
            left: 100,
            behavior: "instant",
          });
        }
        window.removeEventListener("scroll", listener);
      }
    }
    window.addEventListener("scroll", listener);
    window.scrollTo({
      top: top - topValMargin,
      left: 100,
      behavior: behavior,
    });
  }
};

const scrollUptoTo = (elmId, topValMargin = 70) => {
  if (isSeparateMenuVariant()) {
    if (elmId.includes("element_catg_")) {
      let elementId = elmId.replace("element_catg_", "category_items_id_");
      onlyShowCategory(elementId);
      scrollUptoTo("pageTop");
    } else if (elmId === "pageTop") {
      scrollPageTo(elmId, 158, "instant");
    }
  } else {
    scrollPageTo(elmId, topValMargin);
  }
};

const scrollUptoMenuTop = (topVal = 70) => {
  const menuArray = document.querySelectorAll('*[id^="element_catg_"]');
  if (menuArray.length > 0) {
    if (isSeparateMenuVariant()) {
      let elementId = menuArray[0].id.replace(
        "element_catg_",
        "category_items_id_"
      );
      onlyShowCategory(elementId);
      scrollUptoTo("pageTop");
    } else {
      let top = menuArray[0].offsetTop;
      window.scrollTo({
        top: top - topVal, //70
        left: 100,
        behavior: "smooth",
      });
    }
  }
};

const isSeparateMenuVariant = () => {
  let exp = store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
  if (
    exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
      VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
    exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
      VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
    (LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") ===
      PageNames.NEXTGEN_LINKREWRITE_HOME &&
      !(
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X
      ))
  ) {
    return true;
  }
  return false;
};

const getToppingPriceForSize = (toppingsArray, toppingId, sizeId) => {
  let _ = 0;
  for (let i = 0; i < toppingsArray.length; i++) {
    if (toppingsArray[i].toppingId == toppingId) {
      _ = +toppingsArray[i].price[sizeId];
      break;
    }
  }
  return _;
};

const toppingsNameByToppingId = (mainArry, allTopngs, data) => {
  let currentToppingsName = [];
  if (mainArry?.length > 0 && data?.length > 0) {
    currentToppingsName = mainArry.filter((i) => {
      if (data.sort().toString() == i.addTopngs.sort().toString()) {
        return i;
      }
    });
  }
  let obj = currentToppingsName[0] || [];
  if (obj.addTopngs) {
    let newObj = obj.addTopngs.map((i) => Number(i));
    return allTopngs
      .filter((j) => newObj.includes(Number(j.toppingId)))
      .map((o) => o.name)
      .join();
  } else {
    return "";
  }
};

const currentCrustName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let ary = [];
  if (arry && result) {
    ary = arry.filter((i) => i.crustName == result.crustName);
  }
  return ary[0]?.crustName || "";
};

const currentSizeName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let name = [];
  if (arry && result) {
    name = arry.filter((i) => i.sizeName == result.sizeName);
  }
  return name[0]?.sizeName || "";
};

const deepCopyArry = (data) => {
  return JSON.parse(JSON.stringify(data));
};
const sortQniqueArry = (data) => {
  return Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
};

const getWidgetWidthHeight = (
  itemsInScreen = 1.75,
  aspectRatio = 1,
  gap = 28,
  minWidth = 300
) => {
  let width = (window.innerWidth - gap) / itemsInScreen;
  let height = width / (aspectRatio + gap);
  return {
    width: width >= minWidth ? width : minWidth,
    height: height,
  };
};

const amplitudeEventObj = (
  userAction,
  sectionName,
  sectionPosition,
  preObj
) => {
  return {
    userAction,
    sectionName,
    sectionPosition,
    ...(preObj.positionWithinSection && {
      positionWithinSection: preObj.positionWithinSection,
    }),
    ...(preObj.category && { category: preObj.category }),
    ...(preObj.subCategory && { subCategory: preObj.subCategory }),
    ...(preObj.orderType && { orderType: preObj.orderType }),
    ...(preObj.searchSection && { searchSection: preObj.searchSection }),
    ...(preObj.searchQuery && { searchQuery: preObj.searchQuery }),
    ...(preObj.entryFrom && { entryFrom: preObj.entryFrom }),
    ...(preObj.categoryPosition && {
      categoryPosition: preObj.categoryPosition,
    }),
    ...(preObj.offerType && { offerType: preObj.offerType }),
    ...(preObj.milestoneStage && { milestoneStage: preObj.milestoneStage }),
    ...(preObj.offerStage && { offerStage: preObj.offerStage }),
    ...(preObj.impressionType && { impressionType: preObj.impressionType }),
    ...(preObj.scrollType && { scrollType: preObj.scrollType }),
    ...(preObj.enrollmentStatus && {
      enrollmentStatus: preObj.enrollmentStatus,
    }),
    ...(preObj.points && { points: preObj.points }),
    ...(preObj.loginStatus && { loginStatus: preObj.loginStatus }),
    ...(preObj.actionType && { actionType: preObj.actionType }),
    ...(preObj.addToCart && { addToCart: preObj.addToCart }),
    ...(preObj.sellerType && { sellerType: preObj.sellerType }),
    ...(preObj.popularityType && { popularityType: preObj.popularityType }),
    ...(preObj.addCounter && { addCounter: preObj.addCounter }),
    ...(preObj.price && { price: preObj.price }),
    ...(preObj.size && { size: preObj.size }),
    ...(preObj.crust && { crust: preObj.crust }),
    ...(preObj.isIrctcOrder && { isIrctcOrder: preObj.isIrctcOrder }),
    ...(preObj.upsell && { upsell: preObj.upsell }),
    ...(preObj.upsellStatus && { upsellStatus: preObj.upsellStatus }),
    ...(preObj.eventCategory && { eventCategory: preObj.eventCategory }),
    ...(preObj.eventAction && { eventAction: preObj.eventAction }),
    ...(preObj.itemName && { itemName: preObj.itemName }),
    ...(preObj.itemSku && { itemSku: preObj.itemSku }),
    ...(preObj.ecomCategory && { ecomCategory: preObj.ecomCategory }),
    ...(preObj.addToCartQuantity && {
      addToCartQuantity: preObj.addToCartQuantity,
    }),
    ...(preObj.customisationType && {
      customisationType: preObj.customisationType,
    }),
    ...(preObj.isCustomisable && { isCustomisable: preObj.isCustomisable }),
    ...(preObj.updateType && { updateType: preObj.updateType }),
    ...(preObj.addNonVegToppings && {
      addNonVegToppings: preObj.addNonVegToppings,
    }),
    ...(preObj.addVegToppings && { addVegToppings: preObj.addVegToppings }),
    ...(preObj.changeCrust && { changeCrust: preObj.changeCrust }),
    ...(preObj.changeSize && { changeSize: preObj.changeSize }),
    ...(preObj.close && { close: preObj.close }),
    ...(preObj.entry && { entry: preObj.entry }),
    ...(preObj.replaceToppings && { replaceToppings: preObj.replaceToppings }),
    ...(preObj.add && { add: preObj.add }),
    ...(preObj.resetAll && { resetAll: preObj.resetAll }),
    ...(preObj.update && { update: preObj.update }),
    ...(preObj.resultCount && { resultCount: preObj.resultCount }),
    ...(preObj.topResult && { topResult: preObj.topResult }),
    screenName: preObj.screenName
      ? preObj.screenName
      : PageNames.NEXTGEN_HOMEPAGE,
    Page_Name: preObj.screenName
      ? preObj.screenName
      : PageNames.NEXTGEN_HOMEPAGE,
    previousScreenname: preObj.previousScreenname
      ? preObj.previousScreenname
      : preObj.screenName && preObj.screenName !== PageNames.NEXTGEN_HOMEPAGE
      ? PageNames.NEXTGEN_HOMEPAGE
      : document.referrer,
    ...(preObj.subSection && { subSection: preObj.subSection }),
    ...(preObj.menuCategories?.length > 0 && {
      menuCategories: preObj.menuCategories,
    }),
    ...(preObj.menuCount && { menuCount: preObj.menuCount }),
    ...(preObj.rating_type && {rating_type: preObj.rating_type}),
    ...(preObj.rating && {rating: preObj.rating}),
    ...(preObj.item_tag && {item_tag: preObj.item_tag})
  };
};

const getEcomCategoryFromCode = (code) => {
  let ecomCategory = "";
  if (!code) return ecomCategory;
  if (code.startsWith("PIZ")) {
    ecomCategory = "pizza";
  } else if (code.startsWith("CMB")) {
    ecomCategory = "combo";
  } else if (code.startsWith("BEV")) {
    ecomCategory = "beverage";
  } else if (code.startsWith("CAKE") || code.startsWith("DST")) {
    ecomCategory = "dessert";
  } else {
    ecomCategory = "side";
  }
  return ecomCategory;
};

const getMilestoneStage = (offer) => {
  if (
    offer?.milestonesCouponDTOList &&
    offer.milestonesCouponDTOList.length > 0
  ) {
    for (let i = 0; i < offer.milestonesCouponDTOList.length; i++) {
      let ele = offer.milestonesCouponDTOList[i];
      if (!ele.redeemed) return i + 1;
    }
  } else {
    return 1;
  }
};

const returnsGetItemWQuantity = (cartData, addItemToCart) => {
  let item = [];
  if (cartData) {
    item = cartData.find((i) => i.code == addItemToCart.code);
  }
  if (item) {
    return true;
  } else {
    return false;
  }
};

const jsonParser = (json, defaultVal = {}) => {
  try {
    if (typeof json === "object" || !json) return json;
    return JSON.parse(json);
  } catch (e) {
    return defaultVal;
  }
};

const getSessionStorageValue = (key) => {
  try {
    if (typeof window !== "undefined") {
      return jsonParser(sessionStorage.getItem(key));
    }
  } catch (err) {}
};

const setSessionStorageValue = (key, value) => {
  try {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(key, value);
    }
  } catch (err) {}
};

const replaceToppingText = (cartData, allTopngs, data) => {
  let replaceTopDisplay = "";
  if (cartData.length > 0 && cartData?.length !== undefined) {
    const curObj = cartData[cartData.length - 1];
    const { remTopngs, repTopngs } = curObj;
    if (remTopngs && repTopngs) {
      let removeTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["remTopngs"][0])
      );
      let addTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["repTopngs"][0])
      );
      if (removeTop && addTop) {
        replaceTopDisplay = `${removeTop.name} with ${addTop.name}` || "";
      }
    }
  }
  if (data?.repTopngs?.length !== undefined && data?.repTopngs?.length > 0) {
    return replaceTopDisplay;
  } else {
    return "";
  }
};

const defaultToppingsCustomAtrrArry = (
  currentItemDefaultTopping,
  allTopngs
) => {
  if (currentItemDefaultTopping && allTopngs) {
    return allTopngs
      .filter((item) => currentItemDefaultTopping.includes(item.toppingId))
      .map((i) => i.custAttrField);
  }
};

const getAddressAlias = (
  stores,
  coords = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
    ?.location || ""
) => {
  let footerAddress =
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.footerAddress ||
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.city ||
    "";
  if (LocalStorageFunc.getLocationSource() == "ip") {
    return (
      LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
        ?.city ||
      stores?.city ||
      ""
    );
  }
  let deliveryType = LocalStorageFunc.getDeliveryType();
  if (deliveryType == "P") {
    return "Takeaway from";
  } else if (deliveryType == "DINEIN") {
    return "Dine-in at";
  } else {
    if (!LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]) {
      return stores?.city || stores?.footerAddress || "";
    }
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    try {
      for (const item of userAddresses) {
        if (
          item.longitude == coords.longitude &&
          item.latitude == coords.latitude
        ) {
          return (
            item.customer_address_name ||
            "Home" ||
            item.footerAddress ||
            item.city
          );
        }
      }
    } catch (err) {}
    return footerAddress;
  }
};

const findOrdinalsSufixInDate = (day) => {
  // it will set the appropriate string according to day
  let first = Number(day) % 10;
  let second = Number(day) % 100;
  if (first == 1 && second != 11) {
    return "st";
  }
  if (first == 2 && second != 12) {
    return "nd";
  }
  if (first == 3 && second != 13) {
    return "rd";
  }
  return "th";
};

const getNotAvailablePizzaInStore = (storeItem, currentPizza) => {
  const { menuCode, sizeCode } = currentPizza;
  let isAva = [];
  let pizzaCat = ["PIZ"];
  let nonPizzaCat = {
    SIDES: ["BRD", "NVPARCEL", "TACNV", "VGP"],
    BEVRAGES: ["BEV", "CMB", "CAKE", "DST", "SID", "DIP"],
  };
  if (currentPizza !== undefined && storeItem?.length !== undefined) {
    if (pizzaCat[0] === String(currentPizza.menuCode.slice(0, 3))) {
      isAva = storeItem.find((i) => i.code === currentPizza.menuCode);
    } else {
      if (
        nonPizzaCat.BEVRAGES.includes(String(currentPizza.menuCode.slice(0, 3)))
      ) {
        isAva = storeItem.find((i) => i.code === currentPizza.menuCode);
      } else {
        isAva = storeItem.find((i) => {
          if (i.sizeCode == sizeCode) {
            if (i.code == menuCode) {
              return i;
            }
          }
        });
      }
    }
  }
  if (isAva && Object.keys(isAva)?.length > 0) {
    return false;
  } else {
    return true;
  }
};

const getDomain = () => {
  let domain = window.location.host.toString();
  let index = domain.indexOf(".");
  domain = domain.substr(index, domain.length - 1);
  return domain;
};

const setCookie = (name, value, days, domain) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    ";domain=" +
    (domain || ".dominos.co.in") +
    expires +
    "; path=/";
};

const getCookie = (c_name) => {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
};

const deleteCookie = (name, domain) => {
  if (name) {
    document.cookie =
      name +
      "=;expires=Thu,01 Jan 1970 00:00:01 UTC;path=/;domain=" +
      (domain || ".dominos.co.in");
  }
};

const addKeyToCartWhenReloadsData = (arr) => {
  if (arr && Array.isArray(arr)) {
    return arr?.map((i) => {
      if (
        (i?.addTopngs?.length !== undefined && i?.addTopngs?.length > 0) ||
        i.defaultSizeName !== i.sizeName ||
        i.defaultCrustName !== i.crustName
      ) {
        return { ...i, isUserCustomizable: true };
      } else {
        return { ...i, isUserCustomizable: false };
      }
    });
  } else {
    return [];
  }
};

const getUrlQueryString = () => {
  let _ = "";
  try {
    var url = window.location.href,
      retObject = {},
      parameters;
    if (url.indexOf("?") === -1) {
      return "";
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }

    _ = "?";
    for (const [key, value] of Object.entries(retObject)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
  } catch (e) {
    _ = "";
  }

  return _;
};

const getQueryFromUrl = (urlIs = "") => {
  var retObject = {};
  try {
    var url = urlIs || window.location.href,
      parameters;
    if (url.indexOf("?") === -1) {
      return {};
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
  } catch (e) {
    return {};
  }

  return retObject;
};

const isNoRedirectTrue = () => {
  let queryParams = getQueryFromUrl();
  if (queryParams["noredirect"]) {
    return true;
  } else return false;
};

const checkWindowLocationIncludes = (partial) => {
  return (
    window.location.href.includes(partial) &&
    (window.location.href.includes(partial + "/") ||
      window.location.href.includes(partial + "?") ||
      !window.location.href.split(partial)[1])
  );
};

const isStoreUrlCacheEligible = () => {
  let _ = LocalStorageFunc.getComputedLocationData();
  if (!_?.address_alias) {
    return false;
  }
  if (shouldHideCompleteLocationFlow) {
    return window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId()
    );
  }
  return (
    LocalStorageFunc.getIsStoreIdCacheEligible() &&
    window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId()
    )
  );
};

// const getBuildVersion = () => {
//   return window?.version ? "?ver=" + window.version : ((window?._siteProps_?.props?.app_version) ? ("?ver=" + window._siteProps_.props.app_version): ("?ver=1.0.0"));
// };

const getSitePropsVersion = () => {
  return window?._siteProps_?.props?.app_version
    ? "?ver=" + window?._siteProps_?.props?.app_version
    : "?ver=1.1.1";
};

const prepareImgPath = (url) => {
  if (url.indexOf("https:") != -1) {
    return url + getSitePropsVersion();
  } else {
    return imgBaseUrl + "/" + url + getSitePropsVersion();
  }
};

const getProductImages = (imgArr, catg) => {
  let webp = {},
    jpg = {};
  for (let i = 0; i < imgArr?.length; i++) {
    if (imgArr[i].mediaSize == "Web" + catg) {
      webp = prepareImgPath(imgArr[i].mediaPath);
    } else if (imgArr[i].mediaSize == catg) {
      jpg = prepareImgPath(imgArr[i].mediaPath);
    }
  }
  if (Object.keys(webp).length > 0) {
    return webp;
  } else {
    return jpg;
  }
};

const checkIfMiniAppSwitch = () =>
  window._siteProps_?.props?.miniAppSwitchNgh === "true";

const getMiniAppStorageVal = () => {
  const miniAppSwitch = checkIfMiniAppSwitch();
  if (miniAppSwitch) {
    return LocalStorageFunc.isMiniAppPaytmGpay();
  } else {
    return false;
  }
};

const checkIfIsMiniApp = (miniApp = getMiniAppStorageVal()) =>
  [MINIAPP.GPAY, MINIAPP.PAYTM].includes(miniApp || "");
const checkIfIsGpay = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.GPAY;
const checkIfIsPAYTM = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.PAYTM;
const storeRegex = /\/store|landing|home[^]*\//gm; //might need to change in future

const addUpdateParam = (url, param, paramValue) => {
  if (url.indexOf("?") !== -1) {
    let queryParams = {};
    let queryUrl = url.split("?");
    let parameters = queryUrl[1].split("&");
    for (var i = 0; i < parameters.length; i++) {
      queryParams[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
    // add/update the param
    queryParams[param] = paramValue;

    let _ = "?";
    for (const [key, value] of Object.entries(queryParams)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
    return queryUrl[0] + _;
  }
  url = url + "?&" + param + "=" + paramValue;
  return url;
};

const scrollToFromSessionKey = () => {
  let landingPageKey = LocalStorageFunc.getSessionStorageKey("LANDING_PAGE");
  const categoryData = store.state.ProductItems.allCategoryId;
  if (
    typeof landingPageKey === "string" &&
    landingPageKey.startsWith("/menu")
  ) {
    landingPageKey = landingPageKey.replace("/menu", "");
    if (landingPageKey === "") {
      scrollUptoMenuTop();
    } else {
      landingPageKey = landingPageKey.slice(1);
      let landingPageKeyIsNum = /^\d+$/.test(landingPageKey) || false;
      Object.values(categoryData).forEach((val) => {
        let categoryName = val?.categoryName || "";
        categoryName = categoryName.replace(/[^A-Z0-9]+/gi, "-").toLowerCase(); //remove spaces,special-character and replace it with '-' hyphen
        if (
          landingPageKey === categoryName ||
          Number(landingPageKey) === val.categoryId
        ) {
          store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            val.categoryName
          );
          scrollUptoTo("element_catg_" + val.categoryId);
        }
      });
    }
  }
};

const locationCalls = () => {
  if (window.location.href.includes(getCurrentStoreFolder())) {
    let payload = LocalStorageFunc.getCoordsFromRecentLocation();
    if (payload) {
      payload.source = LocalStorageFunc.getLocationSource();
    }
    if (
      LocalStorageFunc.getDeliveryType() != "D" &&
      LocalStorageFunc.getCoordsForTakeaway()
    ) {
      store.dispatch(
        keyMapsAction.GEO_CODE_API_COMBO,
        LocalStorageFunc.getCoordsForTakeaway()
      );
    } else if (payload?.source == "ip") {
      if (LocalStorageFunc.getHideLocationPopupOnceFromSession()) {
        store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
        LocalStorageFunc.unsetSessionStorageKey("hideLocationPopupOnce");
      } else {
        // this.showLocationPermissionModal = true;
        if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
          // this.handleLocationPermissionModal(true);
        } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
          // this.handleLocationPermissionModal(false);
        }
      }
    } else if (
      payload?.coords?.latitude &&
      LocalStorageFunc.isLocationSelectedFromPwaV2()
    ) {
      store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, payload);
    } else {
      if (!shouldHideCompleteLocationFlow) {
        // this.showLocationPermissionModal = true;
        if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
          // this.handleLocationPermissionModal(true);
        } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
          // this.handleLocationPermissionModal(false);
        }
      }
    }
  } else {
    window.location.href =
      projectBasePathWithFolder +
      getCurrentStoreFolder() +
      LocalStorageFunc.storeId() +
      getUrlQueryString();
  }
};

const startupAppiCalls = () => {
  store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
  store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE, {});
  if (isStoreUrlCacheEligible()) {
    store.commit(keyMapsMutation.UPDATE_IS_LOCATION_SETTLED, {});
    let payload = LocalStorageFunc.getCoordsFromRecentLocation();
    store.dispatch(keyMapsAction.CACHED_STORE_API, payload);
  } else {
    locationCalls();
  }
  LocalStorageFunc.isLoggedIn() && store.dispatch(keyMapsAction.LOYALITY_API);
  LocalStorageFunc.isLoggedIn() &&
    store.dispatch(keyMapsAction.WALLET_BALANCE_API);
  store.dispatch(keyMapsAction.PIZZA_TOPPING_API);
  store.dispatch(keyMapsAction.WELCOME_OFFER_API, {});
  store.dispatch(keyMapsAction.PERSONALIZATION_API, {});

  let exp = store.state.Config.vwoExperiments;
  // if (
  //   this.isMenuSequencingEnabled() &&
  //   exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
  //     VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_R
  // ) {
  //   this.$store.dispatch(keyMapsAction.MENU_SEQUENCING_API, {});
  // }

  /* this.$store.dispatch(keyMapsAction.LEFT_MENU_API, {}); */
  LocalStorageFunc.getGetOfferSuccess()?.welcomeOfferGetStatus !== undefined &&
    store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_RESPONSE, {
      welcomeOfferGetStatus:
        LocalStorageFunc.getGetOfferSuccess().welcomeOfferGetStatus,
    });
};

const getLinkRewriteFromSiteprops = () => {
  return window._siteProps_?.link_rewrite || "";
};

const initializeUtmAttributes = () => {
  const utmAttributes = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: ''
  };
  const { utm_source, utm_medium, utm_campaign } = LocalStorageFunc.getUtmAttributes() || utmAttributes;
  const queryParams = getQueryFromUrl();
  const {
    utm_source: utmSourceQuery = 'direct',
    utm_medium: utmMediumQuery = 'direct',
    utm_campaign: utmCampaignQuery = 'direct'
  } = queryParams;
  if (
    (utmSourceQuery !== 'direct' && utm_source !== utmSourceQuery) ||
    (utmMediumQuery !== 'direct' && utm_medium !== utmMediumQuery) ||
    (utmCampaignQuery !== 'direct' && utm_campaign !== utmCampaignQuery)
  ) {
    const updatedUtmAttributes = {
      ...utmAttributes,
      utm_source: utmSourceQuery,
      utm_medium: utmMediumQuery,
      utm_campaign: utmCampaignQuery,
      utm_source_medium: `${utmSourceQuery}-${utmMediumQuery}`
    };
    LocalStorageFunc.setUtmAttributes(updatedUtmAttributes);
    LocalStorageFunc.setUtmTimestamp(new Date().getTime());
  } else {
    const updatedUtmAttributes = {
      utm_source: utm_source || utmSourceQuery,
      utm_medium: utm_medium || utmMediumQuery,
      utm_campaign: utm_campaign || utmCampaignQuery,
      utm_source_medium: `${utm_source || utmSourceQuery}-${
        utm_medium || utmMediumQuery
      }`
    };
    LocalStorageFunc.setUtmAttributes(updatedUtmAttributes);
  }
  if (
    new Date().getTime() -
      parseInt(LocalStorageFunc.getUtmTimestamp() || '0', 10) >
    3600000 * 48
  ) {
    LocalStorageFunc.setUtmAttributes({
      utm_source: 'direct',
      utm_medium: 'direct',
      utm_campaign: 'direct',
      utm_source_medium: 'direct-direct'
    });
  }
}

const decryptData = (data) => {
  if (!data) {
    console.error("No data provided for decryption");
    return data;
  }

  try {
    const rawBytes = CryptoJs.AES.decrypt(data, keyForEncryDecry);
    const decryptedDataString = rawBytes.toString(CryptoJs.enc.Utf8);
    const decryptedData = JSON.parse(decryptedDataString);

    return decryptedData;
  } catch (error) {
    console.error("Error decrypting data:", error);
    return data;
  }
};

const encryptData = (data , key) => {
  try {
    const dataString = JSON.stringify(data);//obj
    const encryptedData = CryptoJs.AES.encrypt(
      dataString,
      keyForEncryDecry
    ).toString();

    return encryptedData;
  } catch (error) {
    console.error("Error encrypting data:", error);
    return data;
  }
};

const getMoengageCartData = (
  eventType,
  result,
  itemSelectedToppings = [],
  toppingFormStore,
  UserData = {},
  currentStoreDetails
) => {
  try {
    const selectedToppings = eventType === 'Remove From Cart' ? itemSelectedToppings : result?.addTopngs || [];

    let storageUserData = LocalStorageFunc.getUserData()?.userData;
    if(storageUserData && typeof(storageUserData) === "string"){
      storageUserData = decryptData(storageUserData);
    }

    const balancePoint = UserData?.walletBalance?.loyaltyProgram?.balance?.overall?.points;
    const earnPointsPerOrder = UserData?.walletBalance?.loyaltyProgram?.programConfig?.earnPointsPerOrder;
    const freeItems = UserData?.walletBalance?.loyaltyProgram?.balance?.burnable?.freeItems;

    const sliceBalance = balancePoint / earnPointsPerOrder;
    const vegToppings = [];
    const vegToppingsIds = [];
    const nonVegToppings = [];
    const nonVegToppingsIds = [];

    for(let i = 0; i < selectedToppings.length; i++) {
      const toppingData = toppingFormStore?.find(storeTopping => storeTopping.toppingId === selectedToppings[i]);
      if(toppingData) {
        const { toppingId, name } = toppingData || {};
        if(toppingData.typeName === 'VEG') {
          vegToppings.push(name);
          vegToppingsIds.push(toppingId);
        } else if(toppingData.typeName === 'NONVEG') {
          nonVegToppings.push(name);
          nonVegToppingsIds.push(toppingId);
        }
      }
    }

    const moengageData = {
      "Item ID": result?.id,
      "Product Name": result?.productName?.toLowerCase(),
      "MRP": result?.itemPrice,
      "Quantity": 1,
      "EDV Offer": '',
      "Size": result?.sizeName?.toLowerCase(),
      "Crust": result?.crustName?.toLowerCase(),
      "Product Image URL": result?.cartImage,
      "Entry Page":"Home Page Screen",
      "Veg Topping": vegToppings,
      "Non Veg Topping": nonVegToppings,
      "Veg Topping ID": vegToppingsIds,
      "Non Veg Topping ID": nonVegToppingsIds,
      "Store Name": currentStoreDetails?.name,
      "Store City": currentStoreDetails?.city,
      "Store State": currentStoreDetails?.region,
      "POTP Points Balance": balancePoint,
      "POTP Slice Balance": sliceBalance, 
      "POTP Free Pizzas Balance": freeItems,
      "Channel":"PWA",
      'Mobile Number': storageUserData?.mobile || ''
    };
    return moengageData;
  } catch(err) {
    console.log('Error in getting moengage cart data', err);
  }
};

export default {
  pizzaCounter,
  randomnumber,
  tryJsonParse,
  calculateIsTrueLocationDetectedFromLocationSource,
  takeawayDineinFolder,
  redirectUrlForNonDeliveryOrderType,
  deliveryFolder,
  textLowerAndTrimSpace,
  getPwaV2CurrentCustomisation,
  keybasedProductItem,
  getCategoryIdBasedMenuCodesFromSequencing,
  sequencedProductItems,
  checkIfOrderTypeNonDelivery,
  getCurrentToppingsTotalPrice,
  sendToLoginScreen,
  getAppDownloadLink,
  getCurrentStoreFolder,
  scrollUptoTo,
  deepCopyArry,
  sortQniqueArry,
  getToppingPriceForSize,
  getMilestoneStage,
  getWidgetWidthHeight,
  toppingsNameByToppingId,
  amplitudeEventObj,
  currentCrustName,
  currentSizeName,
  returnsGetItemWQuantity,
  jsonParser,
  getSessionStorageValue,
  replaceToppingText,
  defaultToppingsCustomAtrrArry,
  getAddressAlias,
  findOrdinalsSufixInDate,
  getNotAvailablePizzaInStore,
  getDomain,
  setCookie,
  getCookie,
  deleteCookie,
  addKeyToCartWhenReloadsData,
  getUrlQueryString,
  getQueryFromUrl,
  checkWindowLocationIncludes,
  isStoreUrlCacheEligible,
  getSitePropsVersion,
  prepareImgPath,
  getProductImages,
  checkNextgenVariant,
  isNoRedirectTrue,
  getEcomCategoryFromCode,
  checkIfIsMiniApp,
  checkIfIsGpay,
  checkIfIsPAYTM,
  getMiniAppStorageVal,
  scrollUptoMenuTop,
  redirectToLoginScreen,
  storeRegex,
  scrollUptoMenuTop,
  checkIfMiniAppSwitch,
  addUpdateParam,
  setSessionStorageValue,
  addMissingKeyAccToLoadDataAndProductItems,
  scrollToFromSessionKey,
  startupAppiCalls,
  getLinkRewriteFromSiteprops,
  getNoRedirectFromWindow,
  initializeUtmAttributes,
  getProductHashcode,
  encryptData,
  decryptData,
  getMoengageCartData,
};
